import { AfterViewInit, Component, Input } from '@angular/core';

import { matExpansionAnimations } from '../../animations/expansion.animations';
import { IDataset } from '../../models/dataset';
import { DEFAULT_UI_OPTIONS, IUiOptions } from '../../models/ui-options';
import { DatasetService } from '../../services/dataset.service';
import { PlotsService } from '../../services/plots.service';

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: [ './toolbar.component.scss' ],
    animations: [
        matExpansionAnimations.indicatorRotate,
        matExpansionAnimations.zoomInDownload,
        matExpansionAnimations.zoomInFilter,
        matExpansionAnimations.zoomInInfo,
        matExpansionAnimations.zoomInRange,
        matExpansionAnimations.growShrink
    ]
})
export class ToolbarComponent implements AfterViewInit {
    @Input() disabled: boolean;
    @Input() plotId: string;
    @Input() plotType: string;
    title: string;
    subtitle: string;
    collapsed: boolean;
    uiOptions: IUiOptions = DEFAULT_UI_OPTIONS;

    constructor( private _datasetService: DatasetService, private _plotsService: PlotsService ) {}

    ngAfterViewInit() {
        setTimeout( () => {
            this._datasetService.getPlotDatasets$( this.plotId ).subscribe(
                newDatasets => this.setTitle( newDatasets.datasets )
            );
        }, 0 );
    }

    /** combines the names and description of all the datasets for the plot into a title and subtitle */
    setTitle( datasets: IDataset[] ) {
        this.title = this.subtitle = '';
        if ( datasets.length < 1 ) { return; }
        // SPECIAL CASE: If all the datasets are the same ( just plotting different variables ), only keep 1 title
        if ( datasets.every( dataset => dataset.name === datasets[0].name && dataset.offset === 0 ) ) {
            this.title += datasets[0].name;
            this.subtitle += datasets[0].desc;
        } else {
            datasets.filter( dataset => dataset.name || dataset.desc ).forEach( ( dataset, index, arr ) => {
                this.title += ( dataset.offset !== 0 ) ? dataset.name + ' (+' + dataset.offset + ')' : dataset.name;
                this.subtitle += dataset.desc;
                if ( index < arr.length - 1 ) {
                    this.title += ' / ';
                    if ( this.subtitle ) {
                        this.subtitle += ' / ';
                    }
                }
            });
        }
    }

    closePlot() {
        this._plotsService.removePlot( this.plotId );
    }
}
